import React from "react";
import { useNavigate } from "react-router-dom";
import { useAvailableFilters } from "web/react/hooks/filters/use-available-filters";
import { ArrowMenu } from "./arrow-menu";

export function AdvancedFilters(): JSX.Element {
    const navigate = useNavigate();
    const availableFilters = useAvailableFilters();

    const items = [
        {
            id: "product_type",
            content: "Categories",
            onAction: () => navigate("/categories"),
        },
        {
            id: "color",
            content: "Colors",
            onAction: () => navigate("/colors"),
        },
        {
            id: "material",
            content: "Materials",
            onAction: () => navigate("/materials"),
        },
        {
            id: "sizes",
            content: "Sizes",
            onAction: () => navigate("/sizes"),
        },
        {
            id: "designer_slug",
            content: "Designers",
            onAction: () => navigate("/designers"),
        },
        {
            id: "retailer_slug",
            content: "Stores",
            onAction: () => navigate("/stores"),
        },
    ]?.filter(({ id }) => availableFilters?.includes(id));

    return <ArrowMenu items={items} />;
}
